import React, {useEffect, useRef} from "react";
import { Screen } from '~common/screen';
import { Styled } from './styled'
import { StyledScreen } from '~common/screen'
import { isMobile } from '~helpers/methods'
import { config, ILogo } from './config'

const PartnersScreen = () => {
  const imagesContainerRef = useRef(null)

  useEffect(() => {
    if (isMobile() && (imagesContainerRef || {}).current) {
      const container  = imagesContainerRef.current
      container.scrollLeft = (container.scrollWidth - container.offsetWidth) / 2
    }
  }, [imagesContainerRef])

  return (
    <Screen
      title={<span><StyledScreen.GreenText>3900+</StyledScreen.GreenText> компаний используют<br />наш сервис каждый день</span>}
      bottomLine={true}
    >
      <Styled.ImagesContainer ref={imagesContainerRef}>
        <Styled.ImagesRow>
        {
          config.logos.map((logo: ILogo) => {
            return (
              <Styled.Logo key={logo.alt}>
                <img src={logo.src} alt={logo.alt} />
              </Styled.Logo>
            )
          })
        }
        </Styled.ImagesRow>
      </Styled.ImagesContainer>
    </Screen>
  )
}

export { PartnersScreen }